<template>
  <b-modal
      id="remark-form-modal"
      title="หมายเหตุ"
      hide-footer
    >
    <form @submit.prevent="onSubmit">
      <b-form-group
          label-for="remark"
      >
        <b-form-textarea
            id="remark"
            v-model="remarkForm.note"
        ></b-form-textarea>
      </b-form-group>
      <div class="text-right">
        <b-button
          variant="light"
          class="mr-2"
          @click="closeModal"
        >
          {{ $t('buttons.cancel')}}
        </b-button>
        <b-overlay
          :show="isLoading"
          rounded
          spinner-small
          class="d-inline-block"
        >
          <b-button
            type="submit"
            variant="primary"
            block
          >
            {{ $t('buttons.confirm')}}
          </b-button>
        </b-overlay>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      remarkForm: {
        note: '',
      },
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.player.isUpdatingPlayer,
    })
  },
  watch: {
    value(val) {
      if (val) {
        this.setData()
      }
    },
  },
  created() {
    this.setData()
  },
  methods: {
    ...mapActions(['fetchPlayer', 'updatePlayer']),
    setData() {
      if ((this.value?.id || '').length) {
        const data = JSON.parse(JSON.stringify(this.value))
        this.fetchPlayer(this.value.id)
        this.remarkForm = { ...data }
      } else {
        this.remarkForm = { note: '' }
      }
    },
    closeModal() {
      this.$bvModal.hide('remark-form-modal')
    },
    async onSubmit() {
      const form = {
        playerId: this.value.id,
        data: {
          note: this.remarkForm.note
        },
        search: this.search
      }
      await this.updatePlayer(form)
      this.$emit('finish')
    },
  },
}
</script>